// eslint-disable-next-line import/prefer-default-export
export enum MenuFeature {
  PRICE_OPTIONS = 0,
  TAX_INCLUDED = 1,
}
